import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import * as constants from '../../../../static/constants'
import { Button, Panel } from '../../../atoms'
import { Form } from '../../../molecules'
import { AgentNav } from '../../../organisms'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  model: string
  title: string
  fields: any
  indexLink: string
  formItems: any
  hideAgentNav?: boolean
  handleSubmit(initialValues, values): void
}

const agentLayoutNew: React.FC<IProps> = props => {
  return (
    <Wrapper>
      {!props.hideAgentNav && <AgentNav active={props.model} />}
      <section className="Index_Main">
        <Panel title={props.title}>
          <Form fields={props.fields} handleSubmit={props.handleSubmit}>
            {props.formItems}
            <div className="Buttons">
              <Button>
                <a href={props.indexLink}>
                  <SvgIcon
                    name="keyboard_arrow_left"
                    className="icon"
                    ariaHidden={true}
                    role="presentation"
                  />
                  {I18n.t('generic.back_to_index')}
                </a>
              </Button>
              <Button primary={true}>{I18n.t('generic.create')}</Button>
            </div>
          </Form>
        </Panel>
      </section>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  min-height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  margin: 0 auto;
  background-color: ${constants.COLORS.background};
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    display: block;
    height: auto;
    min-height: calc(100vh - ${constants.FOOTER_HEIGHT}px);
    padding-top: 55px;
  }

  .Buttons {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 48px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      justify-content: flex-end;
    }

    .Button[type='submit'] {
      width: 160px;
    }

    .Button[type='button'] {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;

      .icon {
        margin-left: -10px;
      }
    }
  }

  .Index_Main {
    width: 100%;
    height: 100%;
    max-width: 1340px;
    min-width: 0;
    margin: 0 auto;
    padding: 22px 40px 80px 46px;

    @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
      padding: 16px 12px;
      margin: 0 auto;
    }
  }

  .InputText + .InputText,
  .InputText + .CheckBox,
  .CheckBox + .CheckBox {
    margin-top: 24px;
  }

  .Panel {
    max-width: none;
  }
`

export default agentLayoutNew
